import fs from 'node:fs'
import { removedDir } from './removed-dir.js'
import { tombstonePath } from './tombstone-path.js'

export function writeTombstone(cwd: string, scope: string): void {
  fs.mkdirSync(removedDir(cwd), { recursive: true })
  fs.writeFileSync(tombstonePath(cwd, scope), '', 'utf-8')
}
